<template>
  <!-- モーダルウインドウ -->
  <transition name="modal">
    <div v-if="isShow" @click.self="clickOutside && hideModal()" :class="classObject" class="content_modal overlay-bg">
      <div class="c-modal__inner content_modal_inner inner-box">
        <div v-if="closeBtn || title" class="c-modal__head content_modal_head"
          :class="onlyCloseBtn ? 'onlyCloseBtn' : ''">
          <!-- 閉じるボタン -->
          <div v-if="closeBtn" @click="hideModal()" class="content_closeBtn default-close-btn-wrapper">
            <Icon name="popup_close_btn" width="23" height="23" />
          </div>
          

        </div>

        <div class="c-modal__content content_modal_content">
          <slot />
        </div>
      </div>
      <!-- /.c-modal__inner -->
    </div>
    <!-- /.c-modal -->
  </transition>
</template>
  
<script>
import _ from "lodash";

export default {
  props: {
    closeBtn: {
      type: Boolean,
      default: true
    },
    clickOutside: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: ""
    },
    widthSize: {
      type: String,
      default: ""
    },
    isHideValid: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    isShow: false,
    scrollTopTimer: false,
    scrollTopFlg: false,
    fromTop: null
  }),

  computed: {
    widthSizeClass() {
      if (!this.widthSize) return;
      return "modal-" + this.widthSize;
    },
    classObject() {
      return ["modal", this.widthSizeClass];
    },
    /**
     * モーダル内のコンテンツが閉じるボタン「x」のみの場合
     * @return { Boolean }
     */
    onlyCloseBtn() {
      if (this.closeBtn && !this.title) return true
      return false
    }
  },

  mounted() {
    // 画面をリサイズした時にもモーダル用に高さを取得
    // const onResize = _.debounce(this.setHeight, 200);
    // window.addEventListener("resize", onResize);
    // this.$once("hook:beforeDestroy", function () {
    //   window.removeEventListener("resize", onResize);
    // });
    // this.setHeight();
  },

  methods: {
    show() {
      if (this.isShow) return;
      this.isShow = true;
      this.$modal.inert = true;
      this.fixScroll();
    },
    hideModal() {
      if (!this.isHideValid) return;
      this.hide();
    },
    hide() {
      if (!this.isShow) return;
      this.isShow = false;
      this.$emit("hide", "");
      this.$modal.inert = false;
      this.fixReset();
    },
    fixReset() {
      document.body.style.top = "";
      document.body.style.position = "static";
      window.scrollTo({ top: parseInt(this.fromTop || "0") });
    },
    fixScroll() {
      // 表示時にスクロールを固定
      if (this.isShow) {
        this.fromTop = window.scrollY;
        document.body.style.width = "100%";
        document.body.style.top = `-${this.fromTop}px`;
        document.body.style.position = "fixed";
      }
    },
    // モーダルのSP用にアドレスバーを除いた画面の高さを取得
    setHeight() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    }
  },

  beforeDestroy() {
    this.fixReset();
  }
};
</script>
  
<style lang="scss" scoped>
.overlay-bg {
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1500;
  display: flex;
  justify-content: center;
  align-items: center;
  .inner-box {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 8px rgba(31, 32, 33, 0.24);
    border-radius: 8px;
    width: 100%;
    max-width: 618px;
    padding: 30px;
    position: relative;
    .default-close-btn-wrapper {
      text-align: right;
      svg {
        cursor: pointer;
        display: inline-block;
      }
    }
  }
  &.modal-md {
    .inner-box {
      max-width: 618px;
      @screen sm {
        border-radius: 6px;
        padding: 20px;
        max-width: 355px;
        width: 100%;
      }
      .default-close-btn-wrapper {
        @screen sm {
          svg {
            width: 15px;
            height: 15px;
          }
        }
      }
    }
  }
}
</style>
  